// @flow

import React from 'react';

import { RenderTableActionButtons } from '../../../commons/tableActionButton/tableActionButton';
import { zoomTableActionsConfig } from '../../../commons/zoomTable/zoomTableConfig';

import styles from './zone.scss';

const settingsButtonImage = require('../../../../assets/images/settings_icon.svg');
const editImg = require('../../../../assets/images/ic_mode_edit_black_24px.svg');
const deleteImg = require('../../../../assets/images/ic_delete_black_24px.svg');
const downloadImg = require('../../../../assets/images/download-symbol.svg');

export const pageObj = {
  pageName: 'SHOP FLOOR MANAGEMENT',
  betaPage: false
};

export const masterDataRouteObj = {
  route: '/masterdata',
  zoomuinewroute: true
};

export const createEditLaneRouteObj = {
  route: '/createlane',
  zoomuinewroute: true
};

export const cellStatus = {
  occupied: 'OCCUPIED',
  available: 'AVAILABLE',
  blocked: 'BLOCKED'
};

export const shopFloorZoneButtonConfig = {
  buttons: [
    {
      // Edit button
      iconRef: editImg,
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log('Edit clicked row {} ', rowData);
        zoomTableActionsConfig.SHOP_FLOOR_ZONE.actions.editLane(rowData);
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '20%',
        height: '50%',
        margin: '5%'
      }
    },
    {
      // delete button
      iconRef: deleteImg,
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log('Delete clicked ', rowData);
        zoomTableActionsConfig.SHOP_FLOOR_ZONE.actions.deleteLane(rowData);
      },
      style: {
        width: '20%',
        height: '50%',
        margin: '5%'
      }
    },
    {
      // download button
      iconRef: downloadImg,
      onClick: rowData => {
        // eslint-disable-next-line no-console
        console.log('Download clicked ', rowData);
        zoomTableActionsConfig.SHOP_FLOOR_ZONE.actions.downloadBarcodes(
          rowData && rowData.cells,
          true,
          {}
        );
      },
      style: {
        width: '20%',
        height: '50%',
        margin: '5%'
      }
    }
  ]
};

export const shopFloorZoneTableConfig = {
  columns: [
    {
      Header: 'Lane Name',
      accessor: 'name',
      Cell: (row: Object) => row.original.name
    },
    {
      Header: 'Lane Type',
      accessor: 'laneType',
      Cell: (row: Object) => row.original.laneType
    },
    {
      Header: 'Location/Number',
      accessor: 'location',
      Cell: (row: Object) => {
        const locations =
          row.original.displayContents && row.original.displayContents.length
            ? row.original.displayContents
                .map(content => content.value)
                .toString()
            : 'N/A';
        return (
          <div className="text-wrap-ellipsis" title={locations}>
            {locations}
          </div>
        );
      }
    },
    {
      Header: 'Available Normal Cell(s)',
      accessor: 'cells',
      Cell: (row: Object) => {
        const cellsToShow =
          row.original.cells &&
          row.original.cells.filter(
            cell =>
              cell.cellStatus === cellStatus.available &&
              cell.name &&
              !cell.isRack
          );
        const normalCellsAvailable =
          cellsToShow && cellsToShow.length
            ? cellsToShow.map(cell => cell.name).toString()
            : 'N/A';
        return (
          <div className="text-wrap-ellipsis" title={normalCellsAvailable}>
            {normalCellsAvailable}
          </div>
        );
      }
    },
    {
      Header: 'Available Rack Cell(s)',
      accessor: 'cells',
      Cell: (row: Object) => {
        const cellsToShow =
          row.original.cells &&
          row.original.cells.filter(
            cell =>
              cell.cellStatus === cellStatus.available &&
              cell.name &&
              cell.isRack
          );
        const rackCellsAvailable =
          cellsToShow && cellsToShow.length
            ? cellsToShow.map(cell => cell.name).toString()
            : 'N/A';
        return (
          <div className="text-wrap-ellipsis" title={rackCellsAvailable}>
            {rackCellsAvailable}
          </div>
        );
      }
    },
    {
      Header: 'Action',
      Cell: (row: Object) => (
        <RenderTableActionButtons
          buttonConfig={shopFloorZoneButtonConfig.buttons}
          rowData={row.original || {}}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No zone data found',
  minRows: 0,
  style: { maxHeight: 'calc(100vh - 22rem)' }
};

export const EditCellMaster = ({ onBtnClick }: Props) => (
  <div
    onClick={() => {
      onBtnClick(false);
    }}
  >
    <img
      className={styles.imageWrapper}
      src={settingsButtonImage}
      alt="Loading..."
    />
  </div>
);

export const DownloadZoneDetails = ({ onBtnClick }: Props) => (
  <div
    onClick={() => {
      onBtnClick();
    }}
  >
    <img className={styles.imageWrapper} src={downloadImg} alt="Loading..." />
  </div>
);
